import { render, staticRenderFns } from "./ThirdParty.vue?vue&type=template&id=6fdd77e2"
import script from "./ThirdParty.vue?vue&type=script&lang=js"
export * from "./ThirdParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports